import isNil from "lodash/isNil";
import { INextQuestionAnswerOptionModel } from "models/dto/ZoomiLxp/Models/Assessments/INextQuestionAnswerOptionModel";
import { ISaveAnswerRequest } from "models/dto/ZoomiLxp/Models/Assessments/ISaveAnswerRequest";
import { ISaveAnswerResponse } from "models/dto/ZoomiLxp/Models/Assessments/ISaveAnswerResponse";
import { ITextTheme } from "models/dto/ZoomiLxp/Models/Common/ITextTheme";
import { CSSProperties } from "react";

export const answerRequest: ISaveAnswerRequest = {
	questionId: 0,
	attemptId: 0,
	answerOptionIds: [],
	answerText: "",
	answerNumber: 0,
};

export const getStyle = (theme: ITextTheme): CSSProperties => {
	const getColor = () => {
		if (theme.color && theme.color.length) return theme.color;
		return document.documentElement.style.getPropertyValue("--text-general");
	};
	return {
		color: getColor(),
		fontWeight: theme.bold ? "700" : "400",
		fontStyle: theme.italic ? "italic" : "normal",
		fontSize: theme.size ? theme.size : "14px",
		textDecoration: theme.underline ? "underline" : "none",
	};
};

export enum Slide {
	First,
	Middle,
	Last,
}

export const checkAnswer = (
	answerOptionsIds: number[],
	answerOption: INextQuestionAnswerOptionModel,
	answerCheckResult?: ISaveAnswerResponse
) => {
	const answerOptionResult = answerCheckResult?.answerResults?.find(
		(res) => res && res.answerOptionId === answerOption.id
	);
	const isChecked: boolean = answerOptionsIds.includes(answerOption.id);
	const isIncorrectAnswer: boolean = !isNil(answerOptionResult) && isChecked && !answerOptionResult?.isRight;
	const isNeverHighlight: boolean =
		isNil(answerCheckResult?.answerResults) && !!answerCheckResult?.allowedAnswerAttempt;

	return { isChecked, isIncorrectAnswer, isNeverHighlight, answerOptionResult };
};
